"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnPrice = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../../utils/classFunctions");
const roundMoney_1 = require("../../../../../../utils/roundMoney");
const Icon_1 = require("../../../../../Icon");
const Tooltip_1 = require("../../../../../Tooltip");
require("./index.scss");
const className = 'flight-passenger-list-price';
const iconMap = {
    now: undefined,
    later: undefined,
    airport: (react_1.default.createElement(Tooltip_1.Tooltip, { modificators: 'white', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Price:PayInAirport', defaultMessage: 'Pay in Airport' }) },
        react_1.default.createElement(Icon_1.Icon, { name: 'airport' }))),
    bill: (react_1.default.createElement(Tooltip_1.Tooltip, { modificators: 'white', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Price:PayByBill', defaultMessage: 'Pay by Bill' }) },
        react_1.default.createElement(Icon_1.Icon, { name: 'bill' }))),
};
const ColumnPrice = (props) => {
    const { onPassengersCountClick = () => undefined } = props !== null && props !== void 0 ? props : {};
    return {
        id: 'price',
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Price:Title', defaultMessage: 'Price' })),
        canSort: true,
        Cell: ({ row }) => {
            const { reservation } = row.original;
            const { invoiceTotalPrice, invoicePaymentTerms, passengersCount, isPaid } = reservation;
            const { locale } = (0, react_intl_1.useIntl)();
            const classNames = (0, classFunctions_1.getClassNames)(className, [
                isPaid === false ? 'not-paid' : undefined,
            ]);
            const passengersValue = passengersCount <= 1 ? '' : (react_1.default.createElement(Tooltip_1.Tooltip, { modificators: ['white', 'center-aligned'], text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Price:passengersCount', defaultMessage: 'Number of passengers' }) },
                react_1.default.createElement("span", { className: `${className}__passengers-count`, onClick: () => onPassengersCountClick(row.original) }, passengersCount)));
            const value = (react_1.default.createElement(react_1.default.Fragment, null,
                isPaid === false ? (react_1.default.createElement(Tooltip_1.Tooltip, { modificators: ['white', 'center-aligned'], text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Price:Unpaid', defaultMessage: 'Unpaid' }) }, (0, roundMoney_1.localizeMoney)(invoiceTotalPrice !== null && invoiceTotalPrice !== void 0 ? invoiceTotalPrice : undefined, locale, 'Flight/Passenger/List/columns/price'))) : (0, roundMoney_1.localizeMoney)(invoiceTotalPrice !== null && invoiceTotalPrice !== void 0 ? invoiceTotalPrice : undefined, locale, 'Flight/Passenger/List/columns/price'),
                react_1.default.createElement("span", { className: `${className}__passengers-value` }, passengersValue)));
            const icon = invoicePaymentTerms ? iconMap[invoicePaymentTerms] : undefined;
            const content = (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: `${className}__icon` }, icon),
                react_1.default.createElement("div", { className: `${className}__value` }, value)));
            return (react_1.default.createElement("div", { className: classNames }, content));
        },
    };
};
exports.ColumnPrice = ColumnPrice;
//# sourceMappingURL=index.js.map